export enum KeyboardKeys {
  ENTER = "Enter",
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  ESCAPE = "Escape",
}
